// export const FleetrifyBgs = "https://fleet3333.s3.us-east-1.amazonaws.com/FleetrifyVideo.mp4";
export const FleetrifyBgs = "https://res.cloudinary.com/do4kzutr7/video/upload/v1771540163/Fleetrify-Bgss_ozbhrx.mp4";


